import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	selector: 'pcm-timesheet-hour-field',
	templateUrl: './timesheet-hour-field.component.html',
	styleUrls: ['./timesheet-hour-field.component.scss']
})
export class TimesheetHourFieldComponent implements OnInit, OnChanges {
	@Input() type: string;
	@Input() title: string;
	@Input() min = 0;
	@Input() max = 24;
	@Input() tooltip = '';
	@Input() placement = 'bottom';
	@Input() disabled: boolean;
	@Input() useBackgroundColor = false;
	@Input() fieldDebounceTimeDelayMs = 500;
	// specify which type of row, because there are styling differences
	@Input() rowSearchable = true;
	@Output() handleInputChange = new EventEmitter();
	@Input() model;
	@Output() modelChange = new EventEmitter();

	changeDebouncer = new Subject<any>();
	internalValue;

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['model']) {
			this.internalValue = this.model;
		}
	}

	ngOnInit(): void {
		// subscribes to its own changes using the 'debounceTime' operator which will delay the emit until a pause
		this.changeDebouncer.pipe(debounceTime(this.fieldDebounceTimeDelayMs))
			.subscribe(value => {
				this.handleModelChange(value);
			});
	}

	// after the debounce time, emit the change outside of this component
	handleModelChange(value) {
		this.internalValue = value;
		let returnValue;
		// if null/undef then keep it null so you can clear the field
		if (value === null || value === undefined) {
			returnValue = null;
		// any invalid characters will become 0
		} else if (isNaN(Number(value))) {
			returnValue = 0;
		} else {
			returnValue = Number(value);
		}
		this.modelChange.emit(returnValue);
		this.handleInputChange.emit();

		// validation may return the same value as previous, which means change detection will not
		// detect that the value was changed back.
		// example: value is 0, -5 is input, so -5 is returned, but validation changes -5 back to 0. this component doesn't detect
		// any change because it already had 0, so it doesn't know to change the field back to 0
		setTimeout(() => this.internalValue = this.model);
	}

	// when an input is received from the input field, don't immediately return it. let the debouncer handle it
	debounceChange(value): void {
		this.changeDebouncer.next(value);
	}
}
